/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar-entry-date.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 11:50
 */

import React from 'react';
import {BoxedLink} from "../../navigation/buttons/nav-buttons";
import {ImageBoxSmall} from "../../boxes/image-box-small";
import {NavigationGroup, NavigationRow} from "../../navigation/layout/nav-layout";
import {formatShortFns} from "../../configuration/configuration";
import {EventEndIcon, fs_regular, ScheduleIcon, TodayIcon} from "../../navigation/icons/nav-icons";
import {splitSeconds} from "../../boxes/date-boxes/date-time-box-long";

const SidebarSimpleEntryEvent = ({peekspace, left= false, time= false}) => {
    const activeSpace = `/${peekspace.username}/space/${peekspace.id}`;
    const isBlocked = peekspace.state === 'BLOCKED';

    return <div className='sidebar-entry-event mt-1 mb-2'>
        <NavigationRow left className='sidebar-entry-date align-items-start'>
            <NavigationGroup>
                <BoxedLink to={activeSpace}>
                    <ImageBoxSmall size='medium'
                                   isToday={peekspace.today}
                                   cancelled={peekspace.state === 'CANCELLED'}
                                   image={peekspace.url}/>
                </BoxedLink>
            </NavigationGroup>
            
            <NavigationGroup className='px-1'>
                <BoxedLink to={activeSpace}>
                    <div className='mr-1'>
                        <div className='sidebar-space-date fw-bolder text-danger'>
                            <TodayIcon size={fs_regular}/> {formatShortFns(peekspace.calendarDate.date)}
                        </div>
                        {peekspace.calendarDateEnd && <div className='sidebar-space-date fw-bolder text-danger'>
                            <EventEndIcon size={fs_regular}/>{formatShortFns(peekspace.calendarDateEnd.date)}
                        </div>}
                        {time && <div className='sidebar-space-date fw-bolder text-blue'>
                            <ScheduleIcon size={fs_regular} className='clr-blue mr-1'/>
                            <span className="text-blue">{splitSeconds(peekspace.calendarDate.startTime)}</span>
                        </div>}
                        <div className='sidebar-space-text lh-1'>{peekspace.name}</div>
                        {isBlocked && <span className='badge bg-danger rounded-pill small'>Cancelled</span>}
                    </div>
                </BoxedLink>
            </NavigationGroup>


        </NavigationRow>
    </div>
}

export default SidebarSimpleEntryEvent;
